import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { ISysData } from 'uApp/interfaces/sysdata';
import { CacheService } from 'uServices/cache.service';
import { StorageService } from 'uServices/storage.service';

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  private sysData: ISysData = {} as ISysData;
  private urlToken = '';
  private partnerId = '';
  private brandId = '';
  private startData = '';

  constructor(private cache: CacheService,
              private storage: StorageService) { }

  public async initSystemBaseObject(): Promise<boolean> {
    console.log('SystemService:  initSystemBaseObject start: ' + new Date().toLocaleTimeString());
    return new Promise<boolean>(async (resolve) => {
      this.sysData = {
        source: 'Сайт AGEnd',
        partnerId: this.partnerId,
        brandId: this.brandId,
        language: 'ua'
      };
      // console.log('SystemService:  initSystemBaseObject finish: ' + new Date().toLocaleTimeString());
      resolve(true);
    });
  }

  // public setUrlToken(value: string): void {
  //   this.urlToken = value;
  //   this.storage.storeKey('urlToken', value);
  // }

  public setStartData(value: string): void {
    const data = value.split(';');
    this.startData = value;
    this.partnerId = data[0];
    this.brandId = data[1];
    this.storage.storeKey('partnerId', this.partnerId);
    this.storage.storeKey('brandId', this.brandId);
    this.storage.storeKey('startData', value);
  }

  public getStartData(): Promise<string> | string {
    // console.log('SystemService: 0  getUrlToken start: ' + new Date().toLocaleTimeString());
    if (!this.startData) {
      // console.log('SystemService: 1 getUrlToken no urlToken in service: get in storage');
      return this.storage.getStorageKeyPromise('startData').then((startData) => {
        // console.log('SystemService: 2 getUrlToken urlToken in storage: ', token);
        const data = startData.split(';');
        this.partnerId = data[0];
        this.brandId = data[1];
        this.startData = startData;
        return this.startData;
      });
    } else {
      return this.startData;
    }
  }

  public getUrlToken(): Promise<string> | string {
    // console.log('SystemService: 0  getUrlToken start: ' + new Date().toLocaleTimeString());
    if (!this.urlToken) {
      // console.log('SystemService: 1 getUrlToken no urlToken in service: get in storage');
      return this.storage.getStorageKeyPromise('urlToken').then((token) => {
        // console.log('SystemService: 2 getUrlToken urlToken in storage: ', token);
        this.urlToken = token;
        return this.urlToken;
      });
    } else {
      return this.urlToken;
    }
  }

  public initSysObjObs(): Observable<boolean> {
    // const param = {
    //   source: 'Сайт AGEnd'
    // };

    this.sysData = {
      source: 'Сайт AGEnd',
      partnerId: this.partnerId,
      brandId: this.brandId,
      language: 'ua'
    };

    return of(true);
  }


  public createNewSystemObj(includeToken = false): Promise<ISysData> {
    return new Promise<ISysData>(async (resolve) => {
      console.log('SystemService:  createNewSystemObj init start: ' + new Date().toLocaleTimeString());
      const bodyData = {} as any;
      if (!this.sysData.source) { await this.initSystemBaseObject(); }
      // for (const [key, val] of Object.entries(this.sysData)) { bodyData[key] = val; }
      Object.entries(this.sysData as any).forEach(([key, val]) => { bodyData[key] = val; });
      if (includeToken) { bodyData.token = this.cache.getData('app-token'); }
      // console.log('SystemService:  createNewSystemObj init finish: ' + new Date().toLocaleTimeString());
      resolve(bodyData);
    });
  }

  public createNewSystemObjObs(includeToken = false): Observable<ISysData> {
    console.log('SystemService:  createNewSystemObj_Obs init start: ' + new Date().toLocaleTimeString());
    // console.log('SystemService:  createNewSystemObj lang: ', bodyData.language);
    // console.log('SystemService:  createNewSystemObj init finish: ' + new Date().toLocaleTimeString());
    let sysObj$;
    if (!this.sysData.source) {
      sysObj$ = this.initSysObjObs().pipe(
        map(() => {
          const bodyData = {} as any;
          // for (const [key, val] of Object.entries(this.sysData as any)) { bodyData[key] = val; }
          Object.entries(this.sysData as any).forEach(([key, val]) => { bodyData[key] = val; });
          if (includeToken) { bodyData.token = this.cache.getData('app-token'); }
          // bodyData.language = this.settings.getCurrLanguage();
          return bodyData as ISysData;
        })
      );
    } else {
      const bodyData = {} as any;
      // for (const [key, val] of Object.entries(this.sysData as any)) { bodyData[key] = val; }
      Object.entries(this.sysData as any).forEach(([key, val]) => { bodyData[key] = val; });
      if (includeToken) { bodyData.token = this.cache.getData('app-token'); }
      // bodyData.language = this.settings.getCurrLanguage();
      sysObj$ = of(bodyData as ISysData);
    }
    return sysObj$;
  }
}
